import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 109    消失对话框
 */

export default class EventDisposeText extends EventBase {
  /**
   * 消失对话框构造函数
   */
  /**
   * 消失对话框构造函数
   * @param {string} param 带的参数
   * @param {Number} indent 带的参数
   */
  public constructor(param: string = '', indent: number = 0) {
    super()
    this.Parameter = [param]
    this.Indent = indent
  }
  /**
   * 剧情ID
   */
  Code = EventID.DisposeText
  /**
   * 获取显示信息
   */
}
